<table border="1" class="changelog-table" *ngIf="items.length > 0">
  <thead>
  <tr>
    <th>Hash</th>
    <th>Date</th>
    <th>body</th>
    <th>Author</th>
    <th>Tag</th>
  </tr>
  </thead>

  <tbody>
  <tr *ngFor="let item of items">
    <td class="center-text width-10"><a [href]="item.stashUrl" target="_blank">{{item.abbrevHash}}</a></td>
    <td class="center-text width-15">{{item.authorDate}}</td>
    <td class="width-50">{{item.subject}}</td>
    <td class="center-text width-15">{{item.authorName}}</td>
    <td class="center-text width-10">{{item.tag}}</td>
  </tr>
  </tbody>
</table>
